import { ActionReducerMap, createReducer, on } from '@ngrx/store';
import { EncountersActions } from '@mona/pdms/data-access-encounters';
import { makeAsyncActionReducer, makeEntitiesReducer } from '@mona/store';
import { NotificationsState } from '../../entities';
import { NotificationsAction } from '../actions/notifications.actions';

export const notificationsFeatureKey = 'notifications';

/**
 * Notifications reducer map
 */
export const reducer: ActionReducerMap<NotificationsState> = {
    notifications: makeEntitiesReducer(
        NotificationsAction.loadNotificationsAction,
        false,
        [NotificationsAction.addUpdateNotificationAction, NotificationsAction.changeReadStatusAction.succeededAction],
        EncountersActions.clearEncounter,
    ),
    hasUnreadNotifications: createReducer(
        false,
        on(
            NotificationsAction.loadHasUnreadNotificationsAction.succeededAction,
            (state, action) => action.payload.hasUnread,
        ),
        on(NotificationsAction.loadHasUnreadNotificationsAction.clearAction, () => false),
    ),
    resolveNotificationAction: makeAsyncActionReducer(NotificationsAction.resolveNotificationAction),
} as any;
